"use client";

import { c as _c } from "react/compiler-runtime";
import { classNames, TextBody, UnstyledButton } from "@opensea/ui-kit";
import { Add } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { COLLECTION_PREVIEW_INTERACTIVE_ELEMENT_CLASS_NAME } from "@/components/collection/overview/constants";
import { openLinksSidebar } from "@/components/studio/page-editor/utils";
export function CollectionPreviewLinks() {
  const $ = _c(6);
  const t = useTranslations("CollectionPreviewLinks");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = classNames("flex items-center gap-1", COLLECTION_PREVIEW_INTERACTIVE_ELEMENT_CLASS_NAME);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Add size={20} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("addLinks");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <UnstyledButton className={t0} onClick={openLinksSidebar}>{t1}<TextBody weight="semibold">{t2}</TextBody></UnstyledButton>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}